import Vue from 'vue'

import d2Container from './d2-container'
import emAutoHeight from './em-auto-height'
import emBox from './em-box'
import emAvatar from './em-avatar'
import emGrid from './em-grid'
import emPager from './em-pager'
import subHeader from './sub-header'

// 注意 有些组件使用异步加载会有影响
Vue.component('d2-container', d2Container)
Vue.component('em-auto-height', emAutoHeight)
Vue.component('em-box', emBox)
Vue.component('em-grid', emGrid)
Vue.component('em-avatar', emAvatar)
Vue.component('em-pager', emPager)
Vue.component('sub-header', subHeader)
Vue.component('d2-page-cover', () => import('./d2-page-cover'))
Vue.component('d2-icon', () => import('./d2-icon'))
Vue.component('d2-icon-svg', () => import('./d2-icon-svg/index.vue'))
